import { LOAD_STATE } from '@shared/axios';
import { createReducer, INITIAL_STATE } from '@shared/redux';
import { checkWaitingListTrial } from '@domain/_screens/header/header-bottom-utils';
import { buildFetchLoggedUserApiConfig } from './logged-user.api';

export const LOGGED_USER_REQUEST_CALLED = '@domain/logged-user/LOGGED_USER_REQUEST_CALLED';
export const LOGGED_USER_REQUEST_SUCCEEDED = '@domain/logged-user/LOGGED_USER_REQUEST_SUCCEEDED';
export const LOGGED_USER_REQUEST_FAILED = '@domain/logged-user/LOGGED_USER_REQUEST_FAILED';

export const UPDATE_LOGGED_USER = '@domain/logged-user/UPDATE_LOGGED_USER';
export const UPDATE_USER = '@domain/logged-user/UPDATE_USER';

export const isLegacyUser = state => state.loggedUser.data.is_legacy;
export const getLoggedUser = state => state.loggedUser.data;
export const getWaitingList = state => state.loggedUser.data.waiting_list;

const isLoggedUserWithoutPlanOrWaitingList = (
    loggedUser, waitingList,
) => !loggedUser.company || !loggedUser.company.plan || !waitingList;

export const shouldShowUpgradePlanButton = (state) => {
    const loggedUser = getLoggedUser(state);
    const waitingList = getWaitingList(state);
    if (isLoggedUserWithoutPlanOrWaitingList(loggedUser, waitingList)) {
        return false;
    }

    const isWaitingListNotTrial = checkWaitingListTrial(waitingList);

    const { is_admin: isAdmin, is_legacy: isLegacy } = loggedUser;
    const { is_free: isCurrentPlanFree } = loggedUser.company.plan;

    return !isLegacy && isAdmin && isCurrentPlanFree && isWaitingListNotTrial;
};

export const shouldShowBillingCenter = (state) => {
    const loggedUser = getLoggedUser(state);
    const waitingList = getWaitingList(state);
    if (!loggedUser || !waitingList) {
        return false;
    }

    const isWaitingListNotTrial = checkWaitingListTrial(waitingList);

    const { is_admin: isAdmin, is_legacy: isLegacy } = loggedUser;

    return !isLegacy && isAdmin && isWaitingListNotTrial;
};

export const fetchLoggedUser = () => ({
    type: LOGGED_USER_REQUEST_CALLED,
    actionTypes: {
        success: LOGGED_USER_REQUEST_SUCCEEDED,
        fail: LOGGED_USER_REQUEST_FAILED,
    },
    config: buildFetchLoggedUserApiConfig(),
});

export const updateLoggedUser = (field, value) => ({
    type: UPDATE_LOGGED_USER,
    field,
    value,
});

export const saveNewLoggedUser = loggedUser => ({
    type: UPDATE_USER,
    loggedUser,
});

export const loggedUserReducers = createReducer({
    [INITIAL_STATE]: {
        loadState: LOAD_STATE.LOADING,
        data: {},
        error: null,
    },
    [LOGGED_USER_REQUEST_CALLED]: state => ({
        ...state,
        loadState: LOAD_STATE.LOADING,
        error: null,
    }),
    [LOGGED_USER_REQUEST_SUCCEEDED]: (state, action) => ({
        ...state,
        loadState: LOAD_STATE.SUCCESS,
        data: action.payload.data,
        error: null,
    }),
    [LOGGED_USER_REQUEST_FAILED]: (state, action) => ({
        ...state,
        loadState: LOAD_STATE.FAIL,
        error: action.payload,
    }),
    [UPDATE_LOGGED_USER]: (state, action) => ({
        ...state,
        data: {
            ...state.data,
            [action.field]: action.value,
        },
    }),
    [UPDATE_USER]: (state, action) => ({
        ...state,
        data: {
            ...action.loggedUser,
        },
    }),
});
